import "./TwoColumnLayoutComponent.scss";
import template from "./TwoColumnLayoutComponent.html";
import {IComponentOptions} from "angular";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const TwoColumnLayout = "tfTwoColumnLayout";

export function twoColumnLayout(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: TwoColumnLayoutController
    };
}

export class TwoColumnLayoutController {

    public readonly widgetDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.widgetDisplay$ = this.buildWidgetDisplay();
    }

    private buildWidgetDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver
                   .observe(Breakpoint.WebLandscape)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
